import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import config from "@/lib/config";
import connectRedis from "@/lib/connectRedis";
import { createCipheriv, createDecipheriv, randomBytes } from "crypto";
import jwt from "jsonwebtoken";

var PasswordToken = /*#__PURE__*/function () {
  function PasswordToken(req, res) {
    var _config$passwordToken, _config$passwordToken2, _config$passwordToken3, _config$passwordToken4, _config$passwordToken5;

    _classCallCheck(this, PasswordToken);

    this.req = req;
    this.res = res;
    this.redis = connectRedis({
      host: process.env.REDIS_HOST || ((_config$passwordToken = config.passwordToken.redis) === null || _config$passwordToken === void 0 ? void 0 : _config$passwordToken.host),
      port: process.env.REDIS_PORT || ((_config$passwordToken2 = config.passwordToken.redis) === null || _config$passwordToken2 === void 0 ? void 0 : _config$passwordToken2.port),
      keyPrefix: config.passwordToken.redis.prefix,
      db: (_config$passwordToken3 = config.passwordToken.redis) === null || _config$passwordToken3 === void 0 ? void 0 : _config$passwordToken3.db
    }, (_config$passwordToken4 = config.passwordToken) === null || _config$passwordToken4 === void 0 ? void 0 : (_config$passwordToken5 = _config$passwordToken4.redis) === null || _config$passwordToken5 === void 0 ? void 0 : _config$passwordToken5.cluster);
  }

  _createClass(PasswordToken, [{
    key: "generateToken",
    value: function generateToken() {
      return randomBytes(16).toString("hex");
    }
  }, {
    key: "generateEncryptionKey",
    value: function generateEncryptionKey() {
      return randomBytes(32);
    }
  }, {
    key: "encrypt",
    value: function encrypt(text, encryptionKey) {
      var iv = randomBytes(config.passwordToken.ivLength);
      var cipher = createCipheriv(config.passwordToken.algorithm, Buffer.from(encryptionKey, "hex"), iv);
      var encrypted = cipher.update(text);
      encrypted = Buffer.concat([encrypted, cipher.final()]);
      return iv.toString("hex") + ":" + encrypted.toString("hex");
    }
  }, {
    key: "decrypt",
    value: function decrypt(text, encryptionKey) {
      var textParts = text.split(":");
      var iv = Buffer.from(textParts.shift(), "hex");
      var encryptedText = Buffer.from(textParts.join(":"), "hex");
      var decipher = createDecipheriv(config.passwordToken.algorithm, Buffer.from(encryptionKey, "hex"), iv);
      var decrypted = decipher.update(encryptedText);
      decrypted = Buffer.concat([decrypted, decipher.final()]);
      return decrypted.toString();
    }
  }, {
    key: "getValue",
    value: function () {
      var _getValue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(jwtToken) {
        var verifiedToken, token, encryptionKey, encryptedText, decryptedText;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                // key : jwtToken
                verifiedToken = jwt.verify(jwtToken, config.passwordToken.jwtSecret);
                token = verifiedToken.token;
                encryptionKey = verifiedToken.encryptionKey;
                _context.next = 6;
                return this.redis.get(token);

              case 6:
                encryptedText = _context.sent;
                decryptedText = this.decrypt(encryptedText, encryptionKey);
                return _context.abrupt("return", decryptedText);

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);
                console.log("password token get value error", _context.t0);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 11]]);
      }));

      function getValue(_x) {
        return _getValue.apply(this, arguments);
      }

      return getValue;
    }()
  }, {
    key: "publish",
    value: function () {
      var _publish = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(key) {
        var token, encryptionKey, encryptedText, jwtToken;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // key : mailAddress
                token = this.generateToken();
                encryptionKey = this.generateEncryptionKey();
                encryptedText = this.encrypt(key, encryptionKey);
                _context2.next = 5;
                return this.redis.multi().set(token, encryptedText).expire(token, config.passwordToken.maxAge).exec();

              case 5:
                jwtToken = jwt.sign({
                  token: token,
                  encryptionKey: encryptionKey
                }, config.passwordToken.jwtSecret);
                return _context2.abrupt("return", jwtToken);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function publish(_x2) {
        return _publish.apply(this, arguments);
      }

      return publish;
    }()
  }, {
    key: "verify",
    value: function () {
      var _verify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(jwtToken) {
        var res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.getValue(jwtToken);

              case 2:
                res = _context3.sent;
                return _context3.abrupt("return", (res === null || res === void 0 ? void 0 : res.length) > 0);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function verify(_x3) {
        return _verify.apply(this, arguments);
      }

      return verify;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(jwtToken) {
        var verifiedToken, token;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                verifiedToken = jwt.verify(jwtToken, config.passwordToken.jwtSecret);
                token = verifiedToken.token;
                _context4.next = 5;
                return this.redis.del(token);

              case 5:
                _context4.next = 10;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](0);
                console.log("password token delete error", _context4.t0);

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 7]]);
      }));

      function _delete(_x4) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }]);

  return PasswordToken;
}();

export { PasswordToken as default };